import { getUserResponse, getAnswerValue } from './answer-helpers';

const CHAPTER_QUESTION_ID = 908;

const CHAPTER_CATEGORY_MAP = {
    1: 'earlyChildhoodAndRoots',
    2: 'schoolYears',
    3: 'youthAndStudentYears',
    4: 'earlyAdulthood',
    5: 'startingAFamily',
    6: 'maturityAndCareer',
    7: 'goldenYears'
};

function getChapterLabel(userResponses, labelMap) {
    return getAnswerValue(userResponses, CHAPTER_QUESTION_ID, labelMap);
}

function getChapterCategory(userResponses, categoryMap = CHAPTER_CATEGORY_MAP) {
    const chapterId = getUserResponse(userResponses, CHAPTER_QUESTION_ID)?.id;

    return categoryMap[chapterId];
}

export {
    getChapterLabel,
    getChapterCategory
};
